<template>
  <a-table
    :columns="columns"
    :data-source="tableData"
    :pagination="pagination"
    :row-key="record => record.deviceId"
    :loading="loading"
    @change="handlePagination"
  >
  </a-table>
</template>
<script>
import { Component, Vue, Prop } from 'vue-property-decorator';
import { entryOrLeaveDetails } from '@/services/smart-hat/screen';
import { shareEntryOrLeaveDetails } from '@/services/smart-hat/screen-share';
import { getBackendAuthForOne } from '@/services/oss/oss';

@Component()
export default class DialogGroupTotalDuration extends Vue {
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showQuickJumper: true,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    showTotal: total => this.$t('todo.flow.total', { total }),
  };
  loading = false;
  tableData = [];
  get columns() {
    const list = [
      {
        align: 'left',
        title: '姓名',
        ellipsis: true,
        customRender: (text, record) => (
          <div>
            <a-tooltip placement="top">
              <template slot="title">
                <div
                  onClick={() => {
                    this.copyPhone(record.mobilePhone);
                  }}
                >
                  {this.$t('enterpriseManagement.camera.tableColumn.phone')}：
                  {record.mobilePhone}
                </div>
              </template>
              {record.avatar ? (
                <x-oss-image
                  service={
                    this.hasShare
                      ? {
                          getAuth: getBackendAuthForOne,
                        }
                      : ''
                  }
                  class={this.$style.avatar}
                  ossPath={record.avatar}
                />
              ) : null}
              <span>{record.userName}</span>
            </a-tooltip>
          </div>
        ),
      },
      {
        title: '角色',
        ellipsis: true,
        customRender: (_, record) => (
          <div>
            <a-tooltip placement="top">
              <template slot="title">
                <div>
                  {record.roleList && record.roleList.length > 0 ? (
                    <div>{this.roleNames(record.roleList)}</div>
                  ) : null}
                </div>
              </template>
              <span>
                {record.roleList && record.roleList.length > 0
                  ? record.roleList[0].roleName
                  : '-'}
              </span>
            </a-tooltip>
          </div>
        ),
      },
      {
        align: 'left',
        title: '累计在场时长',
        dataIndex: 'totalDuration',
        ellipsis: true,
        customRender: text => (text ? text + '小时' : ''),
      },
    ];
    if (!this.hasShare) {
      list.push({
        title: this.$t('enterpriseManagement.camera.tableColumn.operation'),
        fixed: 'right',
        key: 'operation',
        ellipsis: true,
        customRender: (_, record) => (
          <span
            style={{
              color: 'var(--font-active)',
              cursor: 'pointer',
            }}
            onClick={() => this.handleDeviceItem(record)}
          >
            详情
          </span>
        ),
      });
    }
    return list;
  }
  @Prop({ type: String }) dayEnum;
  @Prop({ type: String }) id;
  @Prop({ type: Object }) shareParams;
  @Prop({ type: Boolean }) hasShare;
  async getData() {
    this.loading = true;
    try {
      const params = {
        searchDayEnum: this.dayEnum,
        deviceGroupIds: [this.id].toString(),
        current: this.pagination.current,
        size: this.pagination.pageSize,
      };
      const { records, total } = this.hasShare
        ? await shareEntryOrLeaveDetails(params, this.shareParams)
        : await entryOrLeaveDetails(params);
      this.tableData = records;
      this.pagination.total = total;
      // eslint-disable-next-line no-empty
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
  handleDeviceItem(item) {
    const route = this.$router.resolve({
      path: `/hat/clock?key=2&userId=${item.userId}&date=${this.dayEnum}`,
    });
    window.open(route.href, '_blank');
  }
  roleNames(list) {
    let str = list.reduce((v, a) => v + a.roleName + '、', '');
    if (str.slice(-1) === '、') {
      str = str.slice(0, -1);
    }
    return str;
  }
  handlePagination(data) {
    this.pagination = data;
    this.getData();
  }
  mounted() {
    this.getData();
  }
}
</script>
<style lang="less" module>
.avatar {
  height: 0.24rem;
  width: 0.24rem;
  border-radius: 50%;
  object-fit: cover;
  transform: translateY(28%);
  margin-right: 0.1rem;
}
</style>
